<template>
  <div class="schoolView">
    <p>学校设置</p>
    <div class="school">
      <div class="info">
        <div class="reset" @click="showModal">
          <a-icon type="edit" />
          <span>修 改</span>
        </div>
        <a-modal title="更改学校年级设置" v-model="visible" @ok="handleOk" cancelText="取消" okText="保存" :okButtonProps="{ props: {disabled: isReady} }">
          <p>请选择学校中包含的年级</p>
          <div class="gradeSet">
            <div class="primarySchool">
              <div :style="{ borderBottom: '0px solid #E9E9E9' }">
                <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange" :checked="checkAll">
                  小学
                </a-checkbox>
              </div>
              <a-checkbox-group class="checkBox" :options="plainOptions" v-model="checkedList" @change="onChange" />
            </div>
            <div class="primarySchool">
              <div :style="{ borderBottom: '0px solid #E9E9E9' }">
                <a-checkbox :indeterminate="indeterminate1" @change="onCheckAllChange1" :checked="checkAll1">
                  初中
                </a-checkbox>
              </div>
              <a-checkbox-group class="checkBox" :options="plainOptions1" v-model="checkedList1" @change="onChange1" />
            </div>
            <div class="primarySchool">
              <div :style="{ borderBottom: '0px solid #E9E9E9' }">
                <a-checkbox :disabled="checkAllZZ2 || !!checkedListZZ2.length" :indeterminate="indeterminate2" @change="onCheckAllChange2" :checked="checkAll2">
                  普通高中段
                </a-checkbox>
              </div>
              <a-checkbox-group :disabled="!!checkedListZZ2.length" class="checkBox" :options="plainOptions2" v-model="checkedList2" @change="onChange2" />
            </div>
            <!-- <div class="primarySchool" v-if="userInfo.SCHOOL_TYPE !== 2">
              <div :style="{ borderBottom: '0px solid #E9E9E9' }">
                <a-checkbox :indeterminate="indeterminate3" @change="onCheckAllChange3" :checked="checkAll3">
                  大学 
                </a-checkbox>
              </div>
              <a-checkbox-group class="checkBox" :options="plainOptions3" v-model="checkedList3" @change="onChange3" />
            </div> -->
            <div class="primarySchool">
              <div :style="{ borderBottom: '0px solid #E9E9E9' }">
                <a-checkbox :disabled="checkAll2 || !!checkedList2.length" :indeterminate="indeterminateZZ2" @change="onCheckAllChangeZZ2" :checked="checkAllZZ2">
                  中等职业学段
                </a-checkbox>
              </div>
              <a-checkbox-group :disabled="!!checkedList2.length" class="checkBox" :options="plainOptionsZZ2" v-model="checkedListZZ2" @change="onChangeZZ2" />
            </div>
          </div>
          <div class="contact">
            <div>
              <p>学校联系人:</p>
              <a-input placeholder="请输入" v-model="name"/>
            </div>
            <div>
              <p>学校联系方式:</p>
              <a-input placeholder="请输入" v-model="phone"/>
            </div>
          </div>
        </a-modal>
        <div class="gradeInfo">
          <div>
            <p>学校年级架构:</p>
            <!-- <span class="grade">一年级</span>
            <span class="grade">二年级</span>
            <span class="grade">三年级</span> -->
            <span class="grade" v-for="item in schoolGrades" :key="item">{{item}}</span>
          </div>
          <div class="contact">
            <div>
              <p>学校联系人:</p>
              <!-- <a-input placeholder="请输入" v-model="name"/> -->
              <div class="inputH">
                <span>{{schoolUserInfo.name ? schoolUserInfo.name : ''}}</span>
              </div>
            </div>
            <div>
              <p>学校联系方式:</p>
              <div class="inputH">
                <span>{{schoolUserInfo.phone ? schoolUserInfo.phone : ''}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import STUDENTFUN from '@/util/studentFun'
  export default {
    name: 'UserAccount',
    data () {
      return {
        name: null,
        phone: null,
        visible: false,
        checkedList: [],
        checkedList1: [],
        checkedList2: [],
        checkedListZZ2: [],
        checkedList3: [],
        indeterminate: false,
        indeterminate1: false,
        indeterminate2: false,
        indeterminateZZ2: false,
        indeterminate3: false,
        checkAll: false,
        checkAll1: false,
        checkAll2: false,
        checkAllZZ2: false,
        checkAll3: false,
        plainOptions: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级'],
        plainOptions1: ['初一年级', '初二年级', '初三年级'],
        plainOptions2: ['高一年级', '高二年级', '高三年级'],
        plainOptionsZZ2: ['中职一年级', '中职二年级', '中职三年级', '中职四年级', '中职五年级'],
        plainOptions3: ['大学一年级', '大学二年级', '大学三年级', '大学四年级']
      }
    },
    computed: {
      ...mapState([
        'teacherAdmin',
        'schoolGrades',
        'updateGrades',
        'schoolUserInfo',
        'userInfo'
      ]),
      isReady(){
        if ((this.checkedList.length !== 0 || this.checkedList1.length !== 0 || this.checkedList2.length !== 0 || this.checkedListZZ2.length !== 0 || this.checkedList3.length !== 0) && (this.name !== null && this.name !== "")  && (this.phone !== null && this.phone !== "")) {
          return false
        }else{
          return true
        }
      }
    },
    methods: {
      ...mapMutations([
        'setGradesMaxMin'
      ]),
      ...mapActions([
        'updateSchoolGrades',
        'getUserInfo',
        'getSchoolInfos'
      ]),
      async handleOk(e){
        this.visible = false;
        console.log(e);
        let grade = []
        if (this.checkedList.length !== 0){
          this.checkedList.map(item =>{
            grade.push(item)
          })
        }
        if (this.checkedList1.length !== 0){
          this.checkedList1.map(item =>{
            grade.push(item)
          })
        }
        if (this.checkedList2.length !== 0){
          this.checkedList2.map(item =>{
            grade.push(item)
          })
        }
        if (this.checkedListZZ2.length !== 0){
          this.checkedListZZ2.map(item =>{
            grade.push(item)
          })
        }
        if (this.checkedList3.length !== 0){
          this.checkedList3.map(item =>{
            grade.push(item)
          })
        }
        let aaaf = (array) => { // 连续选择年级
          var isContinuityArray = true
          array.map((item, index) => {
            if (index < array.length - 1) {
              let current = array[index].id - 1
              if (array[index + 1].id !== current) {
                isContinuityArray = false
              }
            }
          })
          return isContinuityArray;
        }
        if (aaaf(STUDENTFUN.gradeFunction(grade, this.checkAllZZ2 || !!this.checkedListZZ2.length))) { // 判断所选年级是否连续
          let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
          let result = {
            ROLE_ID: userInfo.role_id,
            SCHOOL_ID: userInfo.school_id,
            UID: this.teacherAdmin.uid,
            DATA: {
              MAX_GRADE: STUDENTFUN.gradeFunction(grade, this.checkAllZZ2 || !!this.checkedListZZ2.length)[0].id,
              MIN_GRADE: STUDENTFUN.gradeFunction(grade, this.checkAllZZ2 || !!this.checkedListZZ2.length)[grade.length - 1].id,
              PHONE_NUMBER: this.phone,
              CREATE_NAME: this.name,
              SCHOOL_TYPE: this.checkAllZZ2 || !!this.checkedListZZ2.length ? 2 : 1
            }
          }
          await this.updateSchoolGrades(result)
          if (this.updateGrades === true){
            this.$message.success('提交成功')
            await this.getUserInfo()
            let gradeList = [STUDENTFUN.gradeFunction(grade, this.checkAllZZ2 || !!this.checkedListZZ2.length)[grade.length - 1].id, STUDENTFUN.gradeFunction(grade, this.checkAllZZ2 || !!this.checkedListZZ2.length)[0].id]
            this.setGradesMaxMin(gradeList)
            sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList))
            await this.getSchoolInfos({})
          }
          else{
            this.$message.error('提交失败')
          }
        } else {
          this.$message.info('请选择连续的年级~')
        }
      },
      showModal() {
        this.visible = true;
      },
      onChange(checkedList) {
        this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
        this.checkAll = checkedList.length === this.plainOptions.length;
      },
      onChange1(checkedList) {
          this.indeterminate1 = !!checkedList.length && checkedList.length < this.plainOptions1.length;
          this.checkAll1 = checkedList.length === this.plainOptions1.length;
      },
      onChange2(checkedList) {
          this.indeterminate2 = !!checkedList.length && checkedList.length < this.plainOptions2.length;
          this.checkAll2 = checkedList.length === this.plainOptions2.length;
      },
      onChangeZZ2(checkedList) {
          this.indeterminateZZ2 = !!checkedList.length && checkedList.length < this.plainOptionsZZ2.length;
          this.checkAllZZ2 = checkedList.length === this.plainOptionsZZ2.length;
      },
      onChange3(checkedList) {
          this.indeterminate3 = !!checkedList.length && checkedList.length < this.plainOptions3.length;
          this.checkAll3 = checkedList.length === this.plainOptions3.length;
      },
      onCheckAllChange(e,) {
        Object.assign(this, {
            checkedList: e.target.checked ? this.plainOptions : [],
            indeterminate: false,
            checkAll: e.target.checked,
        })
      },
      onCheckAllChange1(e,) {
        Object.assign(this, {
            checkedList1: e.target.checked ? this.plainOptions1 : [],
            indeterminate1: false,
            checkAll1: e.target.checked,
        })
      },
      onCheckAllChange2(e,) {
        Object.assign(this, {
            checkedList2: e.target.checked ? this.plainOptions2 : [],
            indeterminate2: false,
            checkAll2: e.target.checked,
        })
      },
      onCheckAllChangeZZ2(e,) {
        Object.assign(this, {
            checkedListZZ2: e.target.checked ? this.plainOptionsZZ2 : [],
            indeterminateZZ2: false,
            checkAllZZ2: e.target.checked,
        })
      },
      onCheckAllChange3(e,) {
        Object.assign(this, {
            checkedList3: e.target.checked ? this.plainOptions3 : [],
            indeterminate3: false,
            checkAll3: e.target.checked,
        })
      },
    }
  }
</script>

<style>
.schoolView>p{
  font-size:24px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:24px;
}
.schoolView > div {
  margin-top: 24px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(232,232,232,1);
  margin-bottom: 30px;
}
.schoolView .school .info{
  margin:40px 40px 8px;
}
.schoolView .school .info .reset{
  width:89px;
  height:32px;
  border-radius:4px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(232,232,232,1);
  cursor: pointer;
}
.schoolView .school .info .reset .anticon{
  padding: 9px 15px;
}
.schoolView .school .info .gradeInfo{
  margin-top: 32px;
}
.schoolView .school .info .gradeInfo div{
  padding-bottom: 32px;
}
.schoolView .school .info .gradeInfo>div:first-child{
  border-bottom: 1px solid rgba(217,217,217,1)
}
.schoolView .school .info .gradeInfo>div:nth-child(2){
  margin-top: 32px;
}
.schoolView .school .info .gradeInfo span{
  display: inline-block;
  width: 88px;
  text-align: right;
}
.schoolView .school .info .gradeInfo .grade{
  text-align: center;
  background:rgba(232,232,232,1);
  border-radius:4px;
  width: 105px;
  margin-right: 16px;
  margin-bottom: 10px;
  padding: 5px 0px;
}
.contact{
  display: flex;
}
.contact div{
  margin-right: 16px;
}
.schoolView .school .info .gradeInfo .contact{
  padding-bottom: 0;
}
.schoolView .school .info .gradeInfo .contact .inputH{
  height: 63px;
}
.schoolView .school .info .gradeInfo .contact span{
  display: inline-block;
  width: 250px;
  height: 42px;
  border-radius:4px;
  border:1px solid rgba(217,217,217,1);
  text-align: left;
  padding: 10px 10px;
}
.schoolView .school .info .ant-input{
  width: 250px;
  height: 38px;
}
.schoolView .school .info .ant-checkbox-wrapper{
  margin-top: 0px
}
.schoolView .school .info .ant-modal-body{
  text-align: left;
}
.schoolView .school .info .ant-modal-body>p{
  font-size:14px;
  font-weight:400;
  color:rgba(140,140,140,1);
  line-height:14px;
}
.gradeSet{
  margin-bottom: 32px;
}
.gradeSet>p{
  margin-top: 50px;
  font-size:16px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:16px;
}
.gradeSet>div{
  margin-top: 34px;
}
.gradeSet .checkBox{
  margin-top: 18px;
}
.ant-modal-footer .ant-btn-primary{
  background:rgba(81,191,148,1);
  border-radius:4px;
  border-color: rgba(81,191,148,1);
}
.ant-modal-footer .ant-btn-primary[disabled]{
  background: #d9d9d9;
  border-color: #d9d9d9;
}
.ant-modal-footer .ant-btn:nth-child(2) > span{
    color: #ffffff;
}
</style>